
  import React from "react"
  import Component from "/var/jenkins_home/workspace/montadrill.at/src/layouts/index.js"
  import data from "/var/jenkins_home/workspace/montadrill.at/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js